var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: ['container', _vm._isMobile() ? 'mobile' : '']
  }, [_c('Header'), _c('div', {
    class: ['student-container', _vm._isMobile() ? 'no-padding' : '']
  }, [_c('a-layout', [!_vm._isMobile() ? _c('a-layout-sider', [_c('SideMenuStudent', {
    staticClass: "side-menu"
  })], 1) : _vm._e(), _c('a-layout-content', [_vm._isMobile() ? _c('SideMenuStudent', {
    staticClass: "side-menu"
  }) : _vm._e(), _vm._isMobile() ? _c('a-divider') : _vm._e(), _c('a-card', {
    attrs: {
      "bordered": false
    }
  }, [_c('router-view')], 1)], 1)], 1)], 1), _c('Footer')], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };